import React, { useState, useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  AppBar,
  Avatar,
  Button,
  Paper,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import decode from "jwt-decode";

import { LOGOUT } from "../../constants/actionTypes";
import useStyles from "./styles";
import memento from "../../images/memories.png";

const Navbar = () => {
  const classes = useStyles();
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const logout = () => {
    dispatch({ type: LOGOUT });
    history.push("/");
    setUser(null);
  };

  useEffect(() => {
    const token = user?.token;

    if (token) {
      const decodedToken = decode(token);
      if (decodedToken.exp * 1000 < new Date().getTime()) logout();
    }
    setUser(JSON.parse(localStorage.getItem("profile")));
  }, [location, user?.token]);

  return (
    <AppBar className={classes.appBar} position="static" color="inherit">
      <Paper elevation={0} className={classes.brandContainer}>
        <img className={classes.image} src={memento} alt="memento" />
        <Typography
          className={classes.heading}
          component={Link}
          to="/"
          variant="h2"
          align="center"
        >
          Memento
        </Typography>
      </Paper>
      <Toolbar className={classes.toolbar}>
        {user ? (
          <Paper elevation={0} className={classes.profile}>
            <Paper elevation={0} className={classes.userInfo}>
              <Avatar
                className={classes.purple}
                src={user.result.imageUrl}
                alt={user.result.name}
              >
                {user.result.name.charAt[0]}
              </Avatar>
              <Typography
                className={classes.userName}
                variant="h6"
                color="secondary"
              >
                {user.result.name}
              </Typography>
            </Paper>
            <Button
              className={classes.logout}
              variant="contained"
              color="secondary"
              onClick={logout}
            >
              Logout
            </Button>
          </Paper>
        ) : (
          <Button
            component={Link}
            to="/auth"
            variant="contained"
            color="primary"
          >
            Sign In
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
